import { getTagManager } from '../api/tagManager';
export const getMostUsedTags = async (count, page, lang, logger) => {
    const urlParams = new URLSearchParams([['count', count.toString()]]);
    page && urlParams.append('page', page);
    lang && urlParams.append('lang', lang);
    return getTagManager(`tags?${urlParams.toString()}`, {}, logger);
};
